import React from 'react';
import styles from './LoginBox.module.scss';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { message } from 'antd';
import { Checkbox, Button } from 'antd';
import { XInput, XInputPassword, XOKButton } from '@/components/xqxc_ui';
import { setFirstCardPath, setSecondCardPath, setThirdCardPath, setStretchOpen } from '@/reducers/home/actions';
import { setAuth } from '@/reducers/auth/actions';
import { connect } from 'react-redux';
import { setLocalStorage, getLocalStorage } from '@/assets/js/storage';
import { UserOutlined, LockOutlined, PhoneOutlined, KeyOutlined } from '@ant-design/icons';

class LoginBox extends React.Component {

    timeID = '';

    state = {
        loginName: '', // 登录账号
        loginPwd: '', // 登录密码
        keepPwd: false, // 记住密码
        error: false, // 验证错误
        status: 1, // 1：登录状态  2：忘记密码  3：设置新密码、
        telCaptcha: '', // 验证码
        tel: '', // 手机号
        newLoginPwd: '', // 新密码
        newLoginPwdSure: '', // 新密码确认
        alreadySetCaptcha: false, // 是否已经发送验证码，是为true
        time: 60, // 发送验证码倒计时
    }

    componentDidMount() {
        if (getLocalStorage('auth')) {
            const auth = JSON.parse(getLocalStorage('auth'));
            const { loginName, loginPwd, keepPwd } = auth;
            if (auth.keepPwd) {
                this.setState({ loginName, loginPwd, keepPwd });
            } else {
                this.setState({ loginName });
            }
        }
        document.addEventListener('keypress', this.handleEnterKey);
    }

    componentWillUnmount() {
        document.removeEventListener('keypress', this.handleEnterKey);
    }

    handleEnterKey = (e) => {
        const { status } = this.state;
        if (e.keyCode === 13) {
            switch (status) {
                case 1:
                    this._loginHandle();
                    break;
                case 2:
                    this._next();
                    break;
                case 3:
                    this._saveNewPw();
                    break;
            }

        }
    }

    _keepPwdChange = (e) => {
        this.setState({ keepPwd: e.target.checked });
    }

    // 登录操作
    _loginHandle = () => {
        const { setFirstCardPath, setSecondCardPath, setThirdCardPath, setStretchOpen, history, setAuth, accountType } = this.props;
        const { loginName, loginPwd } = this.state;
        const data = {
            loginName,
            loginPwd,
            accountType,
        };
        const reg = /^[0-9a-zA-Z!@#$%^&*(){}_|/'"\\[|\]]*$/; // 数字、字母、特殊字符
        if (loginPwd && loginPwd.toString().length > 16) {
            message.error('密码长度至多为16位');
            return;
        } else if (!reg.test(loginPwd)) {
            message.error('密码仅包括数字、英文、常用符号（表情除外）');
            return;
        }

        setLocalStorage('fromLogin', '1'); // 当fromLogin=1时，表示进入系统要跳到默认页
        http('/?cmd=com.xqxc.api.pig.mis.biz.account.AdminLoginService.getLoginToken', data, 'POST').then((response) => {
            let auth = { ...response.result, loginName: this.state.loginName, loginPwd: this.state.loginPwd, keepPwd: this.state.keepPwd };
            setAuth(auth);
            // 重置相关导航记录
            setFirstCardPath('');
            setSecondCardPath('');
            setThirdCardPath('');
            setStretchOpen(true);
            // 跳转至home
            history.push({ pathname: '/home/' });
            message.success('登录成功');
            this.setState({ status: 1, loginPwd: '', newLoginPwd: '', alreadySetCaptcha: '', telCaptcha: '', tel: '' });
        }).catch((e) => {
            message.error(e.message);
            this.setState({ error: true });
            setLocalStorage('fromLogin', ''); // 当fromLogin=0时，表示进入系统不需要跳到默认页
        });
    };

    // 获取验证码
    _getCaptcha = () => {
        const { accountType } = this.props;
        const { loginName, tel } = this.state;
        const _this = this;
        const data = {
            loginName,
            tel,
            captchaType: 'BACKPASSWORD',
            accountType,
        };

        http('/?cmd=com.xqxc.api.pig.mis.biz.account.AdminLoginService.sendMsgByRetrievePwd', data, 'POST').then((response) => {
            this.setState({ alreadySetCaptcha: true });
            this.timeID = setInterval(function () {
                const { time } = _this.state;
                if (time > 0) {
                    _this.setState({ time: time - 1 });
                } else {
                    clearInterval(_this.timeID);
                    _this.setState({ alreadySetCaptcha: false, time: 60 });
                }
            }, 1000);
        }).catch((e) => {
            message.error(e.message);
        });
    }

    // 忘记密码，点击下一步操作
    _next = () => {
        const { accountType } = this.props;
        const { loginName, tel, telCaptcha } = this.state;
        const data = {
            loginName,
            tel,
            telCaptcha,
            accountType,
        };
        http('/?cmd=com.xqxc.api.pig.mis.biz.account.AdminLoginService.verifyTelCaptcha', data, 'POST').then(() => {
            clearInterval(this.timeID);
            this.setState({ status: 3, alreadySetCaptcha: false, time: 60 });
        }).catch((e) => {
            message.error(e.message);
        });
    }

    // 保存新密码
    _saveNewPw = () => {
        const { accountType } = this.props;
        const { newLoginPwd, newLoginPwdSure, loginName, tel, telCaptcha } = this.state;
        const reg = /^[0-9a-zA-Z!@#$%^&*(){}_|/'"\\[|\]]{6,16}$/; // 数字、字母、特殊字符
        if (!(reg.test(newLoginPwd) && reg.test(newLoginPwdSure))) {
            message.error('密码限制6-16位，允许输入数字、英文、常用符号（表情除外）');
            return;
        } else if (newLoginPwd != newLoginPwdSure) {
            message.error('两次输入的新密码不一致');
            return;
        }
        const data = {
            newLoginPwd,
            loginName,
            tel,
            telCaptcha,
            accountType,
        };
        http('/?cmd=com.xqxc.api.pig.mis.biz.account.AdminLoginService.updatePasswordByCaptcha', data, 'POST').then(() => {
            message.success('修改成功！');
            this.setState({ status: 1, loginPwd: '', newLoginPwd: '', newLoginPwdSure: '', alreadySetCaptcha: '', telCaptcha: '', tel: '' });
        }).catch((e) => {
            message.error(e.message);
        });
    }

    _renderError = (error) => {
        if (error) {
            return (
                <div className={styles.error}>
                    <img className={styles.jinzhi_img} src={require('@/assets/image/jinzhi.png').default} />
                    <p className={styles.jinzhi_text}>您输入的账号密码不匹配，请重新输入</p>
                </div>
            );
        }
    }

    // 忘记密码
    _forgetPw = () => {
        this.setState({ status: 2, alreadySetCaptcha: false });
    }

    // 渲染状态场景
    _renderContent = () => {
        const { status } = this.state;
        switch (status) {
            case 1:
                return this._status1();
            case 2:
                return this._status2();
            case 3:
                return this._status3();
        }
    }

    // 场景1
    _status1 = () => {
        const { loginName, loginPwd, keepPwd, error } = this.state;
        return <div className={styles.handle}>
            <XInput
                style={{ marginLeft: '-10px' }}
                inputStyle={{ width: '384px', height: '46px' }}
                placeholder='请输入用户名'
                prefix={<UserOutlined />}
                value={loginName}
                bindThis={this}
                bindName='loginName'
            />
            <XInputPassword
                style={{ marginLeft: '-10px', marginTop: '20px' }}
                inputStyle={{ width: '384px', height: '46px' }}
                placeholder="请输入密码"
                prefix={<LockOutlined />}
                visibilityToggle={true}
                value={loginPwd}
                bindThis={this}
                bindName='loginPwd'
                onChange={(value) => {
                    const reg = /^[0-9a-zA-Z!@#$%^&*(){}_|/'"\\[|\]]*$/; // 数字、字母、特殊字符
                    if (value && value.toString().length > 16) {
                        message.error('密码长度至多为16位');
                    } else if (!reg.test(value)) {
                        message.error('密码仅包括数字、英文、常用符号（表情除外）');
                    }
                }}
            />
            <div className={styles.rememberme}>
                <Checkbox
                    style={{ width: '110px' }}
                    checked={keepPwd}
                    onChange={this._keepPwdChange}
                >
                    <span className={styles.remembermePw}>记住密码</span>
                </Checkbox>
                <div className={styles.forgetPw} onClick={this._forgetPw}>
                    忘记密码
                </div>
            </div>
            <div className={styles.submit}>
                <Button type="primary" onClick={this._loginHandle}>登录</Button>
            </div>
            {/* {this._renderError(error)} */}
        </div>;
    }

    // 场景2
    _status2 = () => {
        const { loginName, tel, telCaptcha, alreadySetCaptcha, time } = this.state;
        const captchaLabel = alreadySetCaptcha ? '短信已发送(' + time + ')' : '获取验证码';

        return <div className={styles.handle}>
            <XInput
                style={{ marginLeft: '-10px' }}
                inputStyle={{ width: '384px', height: '46px' }}
                placeholder='请输入用户名'
                prefix={<UserOutlined />}
                value={loginName}
                bindThis={this}
                bindName='loginName'
            />
            <XInput
                style={{ marginLeft: '-10px', marginTop: '20px' }}
                inputStyle={{ width: '384px', height: '46px' }}
                placeholder='请输入手机号'
                prefix={<PhoneOutlined />}
                value={tel}
                bindThis={this}
                bindName='tel'
            />
            <div style={{ display: 'flex', marginTop: '20px' }}>
                <XInput
                    style={{ marginLeft: '-10px' }}
                    inputStyle={{ width: '245px', height: '46px' }}
                    placeholder='请输入验证码'
                    prefix={<KeyOutlined />}
                    value={telCaptcha}
                    bindThis={this}
                    bindName='telCaptcha'
                />
                <XOKButton
                    style={{ marginLeft: '10px', flex: 1, with: '128px', height: '46px' }}
                    label={captchaLabel}
                    onClick={this._getCaptcha}
                    disabled={alreadySetCaptcha}
                />
            </div>
            <div className={styles.submit}>
                <Button type="primary" onClick={this._next}>下一步</Button>
            </div>
            <div
                style={{ color: '#1890ff', fontSize: '16px', marginTop: '7px', cursor: 'pointer' }}
                onClick={() => {
                    clearInterval(this.timeID);
                    this.setState({ status: 1, telCaptcha: '', time: 60 });
                }}
            >
                返回登录
            </div>
        </div>;
    }

    // 场景3
    _status3 = () => {
        const { newLoginPwd, newLoginPwdSure } = this.state;

        return <div className={styles.handle}>
            <div
                style={{
                    textAlign: 'center',
                    fontSize: '24px',
                    color: '#666666',
                    fontWeight: 'bold'
                }}
            >
                设置新密码
            </div>
            <XInputPassword
                style={{ marginLeft: '-10px', marginTop: '20px' }}
                inputStyle={{ width: '384px', height: '46px' }}
                placeholder="输入新密码"
                prefix={<LockOutlined />}
                value={newLoginPwd}
                bindThis={this}
                bindName='newLoginPwd'
            />
            <XInputPassword
                style={{ marginLeft: '-10px', marginTop: '20px' }}
                inputStyle={{ width: '384px', height: '46px' }}
                placeholder="确认新密码"
                prefix={<LockOutlined />}
                value={newLoginPwdSure}
                bindThis={this}
                bindName='newLoginPwdSure'
            />
            <div className={styles.submit}>
                <Button type="primary" onClick={this._saveNewPw}>保存</Button>
            </div>
        </div>;
    }

    render() {
        const logo = this.props.accountType == 'COMPANY' ? require('@/assets/image/logooc.png').default : require('@/assets/image/logo.png').default;
        return (
            <div className={styles.login}>
                <div className={styles.title}>欢迎登录</div>
                <div className={styles.userinput}>
                    {this._renderContent()}
                </div>
            </div>
        );
    }
}

LoginBox.propTypes = {
    accountType: PropTypes.string, // 后台类型
    history: PropTypes.object,
    setFirstCardPath: PropTypes.func, // 存储一级导航路径的函数
    setSecondCardPath: PropTypes.func, // 存储二级导航路径的函数
    setThirdCardPath: PropTypes.func, // 存储三级导航路径的函数
    setStretchOpen: PropTypes.func, // 存储导航栏的伸展状态的函数
    setAuth: PropTypes.func, // 存储验证信息
};

export default connect(null, { setFirstCardPath, setSecondCardPath, setThirdCardPath, setStretchOpen, setAuth })(LoginBox);